import { filterOptions } from '@/utils/query-base'

const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
}

export default {
  'transferCustomerCode': {
    title: '转出客户编码',
    type: 'dialog',
    equation: all,
    width: 170,
    dialog: {
      component: 'ClientSelect',
      title: '转出客户编码'
    }
  },
  'transferCustomerName': {
    title: '转出客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'receiveCustomerCode': {
    title: '转入客户编码',
    type: 'dialog',
    equation: all,
    width: 170,
    dialog: {
      component: 'ClientSelect',
      title: '转入客户编码'
    }
  },
  'receiveCustomerName': {
    title: '转入客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
}



// WEBPACK FOOTER //
// ./src/views/apply-for-manage/base-setting/config/transferCustomerSetting.js